<script setup lang="ts">
import { useRouter } from 'vue-router'
import img404 from '@/assets/404.webp'

const router = useRouter()

function goHome() {
  router.push('/')
}

function goBack() {
  router.back()
}
</script>

<template>
  <div class="h-full flex items-center justify-center bg-#fdfdfd">
    <div class="text-center px-6">
      <!-- 图片容器与背景光晕 -->
      <div class="relative inline-block mb-8">
        <div class="absolute inset-0 rounded-full opacity-60 -z-10 translate-y-10 scale-110" />
        <img
          :src="img404"
          alt="404 Not Found"
          class="w-72 h-72 object-contain mx-auto hover:scale-105 transition-transform duration-500"
        >
      </div>

      <!-- 文字提示 -->
      <div class="space-y-3 mb-10 whitespace-nowrap">
        <h1 class="text-4xl font-extrabold text-gray-800 tracking-tight">
          404
        </h1>
        <p class="text-lg text-gray-500 font-medium">
          抱歉，您访问的页面就像这只猫一样，走丢了...
        </p>
      </div>

      <!-- 操作按钮 -->
      <div class="flex items-center justify-center gap-5 whitespace-nowrap">
        <el-button
          type="primary"
          size="large"
          class="!rounded-xl !px-10 !h-12 !font-medium shadow-[0_4px_16px_rgba(59,130,246,0.3)] hover:shadow-[0_6px_20px_rgba(59,130,246,0.4)] hover:-translate-y-0.5 transition-all duration-300"
          @click="goHome"
        >
          返回首页
        </el-button>
        <el-button
          size="large"
          class="!rounded-xl !px-10 !h-12 !font-medium !text-gray-600 border-gray-200 hover:bg-gray-50 hover:text-blue-500 hover:border-blue-200 hover:-translate-y-0.5 transition-all duration-300"
          @click="goBack"
        >
          返回上一页
        </el-button>
      </div>
    </div>
  </div>
</template>
